var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4B4F54",
    strokeLinecap: "square",
    strokeWidth: 1.688
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.15c0 3.716-2.93 6.73-6.545 6.73s-6.546-3.014-6.546-6.73 2.93-6.73 6.546-6.73S14.5 4.434 14.5 8.15z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m12.842 12.627-.534.549 5.585 5.742.534-.549z"
  }))));
};
export default SvgSearch;